import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, ListItemButton, ListItemText } from '@mui/material'

import CustomDialog from 'components/Shared/Dialog'
import { isMobileView } from 'lib/GlobalConstants'
import { dialogStyles } from 'components/Reporting/Overview/ShareDashboard/StyleConstants'
import { setSharableFilterLink } from 'redux/slices/FilterBuilder'
import { useAppSelector, useAppDispatch } from 'redux/Hook'
type Props = {
  isMobileDrawer?: boolean
  customDialogProps?: any
  setModalVisibilityProp?: (val: boolean) => void
}

const ShareDetails = (props: Props) => {
  const { isMobileDrawer, customDialogProps, setModalVisibilityProp } = props
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const {
    filterBuilder: { isSaveFilterActive = false },
  } = useAppSelector((state) => state)

  const buttonComponent = () => {
    return (
      <>
        {isMobileView ? ( // mobile view is checked since we want to open the modal on drawer click
          isMobileDrawer && (
            <>
              <ListItemButton data-testid="share-reporting-details">
                <ListItemText
                  primary={t('reporting.shareDetails.shareBtn')}
                  onClick={() => {
                    if (isSaveFilterActive) {
                      setModalVisibilityProp?.(true)
                    } else {
                      dispatch(setSharableFilterLink(true))
                    }
                  }}
                />
              </ListItemButton>
            </>
          )
        ) : (
          <>
            <Button
              onClick={() => {
                if (isSaveFilterActive) {
                  setModalVisibilityProp?.(true)
                } else {
                  dispatch(setSharableFilterLink(true))
                }
              }}
              variant="outlined"
              aria-label={t('reporting.shareDetails.shareBtn')}
              size="large"
              data-testid="share-reporting-details"
            >
              {t('reporting.shareDetails.shareBtn')}
            </Button>
          </>
        )}
      </>
    )
  }

  return (
    <Box sx={dialogStyles}>
      {buttonComponent()}
      <CustomDialog {...customDialogProps} />
    </Box>
  )
}

export default memo(ShareDetails)
